import { gql } from 'apollo-boost';

export const SEARCH_STUDENTS_FOR_BOOMBASSADOR = gql`
query studentsSearchForBoombassador($name: String!) {
    studentsSearchForBoombassador(name: $name) {
        id
        firstName
        lastName
        boomerAvatarUrl
        classes {
            id
            name
        }
    }
}
`;

export const SELECTED_STUDENT_FROM_BOOMBASSADOR_SEARCH = gql`
query selectedStudentFromBoombassadorSearch($name: String!) {
    studentsSearchForBoombassador(name: $name) {
        id
        firstName
        lastName
        avatarJson
        boomerAvatarUrl
        uncompletedBooks {
            id
            status
            bookType
            book {
                id
                author
                description
                title
                coverUrl
                isbn
                isbn13
            }
        }
        classes {
            id
            name
        }
    }
}
`;

export const ACCEPT_BOOMBASSADOR_ROLE = gql`
mutation acceptBoombassadorRole {
    acceptBoombassadorRole {
        accepted
        errors
    }
}
`;

